import { useMemo, type JSX } from 'react';
import type { BiomarkerSelection, IBiomarkerData, IChartLaneLogScale } from '@/types/PatientDashboard/PatientTimeline.types';
import BiomarkerChart from './BiomarkerChart';
import BiomarkerLegend from './BiomarkerLegend';
import { ChartLaneRow } from './ChartLane.styles';

interface IProps {
  data: IBiomarkerData;
  selection: BiomarkerSelection;
  scale: IChartLaneLogScale;
  onToggle: (variantId: string) => void;
  xPct: (date: string) => number;
}

export default function BiomarkerRow({
  data,
  selection,
  scale,
  onToggle,
  xPct,
}: IProps): JSX.Element {
  const selectedLines = useMemo(
    () => data.lines.filter((line) => selection[line.variantId]),
    [data.lines, selection],
  );

  return (
    <ChartLaneRow>
      <BiomarkerLegend lines={data.lines} selection={selection} onToggle={onToggle} />
      <BiomarkerChart lines={selectedLines} scale={scale} xPct={xPct} />
    </ChartLaneRow>
  );
}
